import { useMemo } from "react";
// Installation instructions:
// https://www.algolia.com/doc/api-client/getting-started/install/
import algoliarecommend from "@algolia/recommend";
import { getAlgoliaIndexName } from "@lib/wrappers/algolia/helpers";
import { useLocale } from "next-intl";

export const useAlgoliaRecommendations = () => {
    const locale = useLocale();
    const appId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID;
    const apiKey = process.env.NEXT_PUBLIC_ALGOLIA_API_KEY;
    const indexName = useMemo(() => getAlgoliaIndexName(locale), [locale]);
    const recommendationClient = useMemo(() => algoliarecommend(appId, apiKey), [appId, apiKey]);
    return { recommendationClient, indexName };
};
